import React from "react";

import ModeratorCommentList from "@components/Screen/ModeratorComments";
import { url_reverse } from "@components/Utils";

export default function ModeratorComments({ developerId, header }) {
    const apiUrl = url_reverse("api:developer:moderator_comments", { developer_id: developerId });
    return <ModeratorCommentList header={header} apiUrl={apiUrl} />;
}
